import { MediaManager } from "../components"


const Media = () => {
  return (
    <div>
        <MediaManager/>
    </div>
  )
}

export default Media